import { OCCModel } from '../occ-model';
import { NumberDecorator } from '../decorators/number.decorator';
import { Expose } from "@nts/std/serialization";
import type { CompanySingleAggregateIdentityInterface, CompanySingleAggregateModelInterface } from '@nts/std/interfaces';

/**
 * Modello per gestire le configurazione che conterranno sempre e solo un aggregato per ditta (una riga).
 */
export class CompanySingleAggregateModel<
  TCompanySingleAggregateIdentity extends CompanySingleAggregateIdentityInterface
> extends OCCModel<TCompanySingleAggregateIdentity> implements CompanySingleAggregateModelInterface<TCompanySingleAggregateIdentity> {

  static override PROPERTY_LIST: string[] = [
    ...OCCModel.PROPERTY_LIST,
    'companyId'
  ];

  private _companyId: number = 0;

  @Expose()
  @NumberDecorator({
    displayNameKey: 'std_CompanySingleAggregateModel_CompanyId'
  })
  get companyId(): number {
    return this.getValueForIdentityValue<number>(() => this._companyId, 'companyId');
  }
  set companyId(value: number) {
    this.setValueForIdentityValue<number>(() => { this._companyId = value; }, value, 'companyId');
  }
}
